import styled, { css } from 'react-emotion';

export const Wrapper = styled.div`
	align-items: center;
	display: flex;
	margin: 0 auto;
	max-width: 400px;

	@media (max-width: 380px) {
		margin-top: 1rem;
	}

	form {
		flex: 1 0 auto;
	}
`

export const Icon = styled.img`
	flex: 0 0 auto;
	margin-right: 5px;
`

export const Title = styled.div`
	color: ${props => props.theme.color};
	font-size: 1rem;
	font-weight: bold;
	margin: 2rem auto 0.75rem;
	text-align: center;
`

export const Theme = {
	container: css`
		display: block;
		font-size: 0.875rem;
		text-align: left;

		@media (max-width: 759px) {
			position: relative;
		}
	`,
	input: css`
		border: 1px solid #D8D8D8;
		box-sizing: border-box;
		color: inherit;
		font-size: inherit;
		line-height: 3;
		padding: 0 0.5rem;
		outline: none;
		width: 100%;
	`,
	suggestionsContainer: css`
		background: white;
		bottom: 0;
		box-sizing: border-box;
		height: 100%;
		line-height: 2;
		overflow: auto;
		position: absolute;
		top: 0;
		z-index: -1;

		@media (min-width: 1024px) {
			right: 0;
			width: 26%;
		}

		@media (min-width: 760px) and (max-width: 1023px) {
			left: 0;
			width: 30%;
		}

		@media (max-width: 759px) {
			left: 0;
			right: 0;
			top: 100%;
			width: 100%;
		}
	`,
	suggestionsContainerOpen: css`
		z-index: 256;

		@media (min-width: 1024px) {
			border-left: 1px solid #D8D8D8;
		}

		@media (min-width: 760px) and (max-width: 1023px) {
			border-right: 1px solid #D8D8D8;
		}
	`,
	suggestionsList: css`
		list-style: none;
		margin: 0;
		padding: 0;
	`,
	suggestion: css`
		border-top: 1px solid #eee;
		cursor: pointer;
		padding: 0 0.25rem;
	`,
	suggestionFirst: css`
		border-top: 0;
	`,
	suggestionHighlighted: css`
		background: rgba(4, 133, 165, 0.1);
	`
};
